import appI18nInstance from 'i18n';

const dateevOptions = [
  { value: 'skr03', label: appI18nInstance.t('export.dateev.skr03') },
  { value: 'skr04', label: appI18nInstance.t('export.dateev.skr04') },
];

const ublOptions = [
  { value: 'ubl21', label: appI18nInstance.t('export.ubl.ubl21_label') },
  { value: 'ublBe', label: appI18nInstance.t('export.ubl.ublBe_label') },
];

const resolveExportError = (error?: string): string =>
  error
    ? appI18nInstance.t(`export.error.${error}`)
    : appI18nInstance.t('export.failed');

export { ublOptions, dateevOptions, resolveExportError };
